/** מזהי פאנלים שנפתחים ממסילת הכלים האנכית — לעימוד משותף (Dock) ולרוחב ה-Drawer */
export type ChatToolsRailPanelId =
  | 'chat-templates-menu'
  | 'ask-ai-dialog'
  | 'chat-user-conversations-menu'
  | 'chat-user-search-messages'
  | 'chat-bot-status-menu'
  | 'contact-opt-out-log'
  | 'contact-service-calls';

const CHAT_TOOLS_RAIL_PANEL_IDS = new Set<ChatToolsRailPanelId>([
  'chat-templates-menu',
  'ask-ai-dialog',
  'chat-user-conversations-menu',
  'chat-user-search-messages',
  'chat-bot-status-menu',
  'contact-opt-out-log',
  'contact-service-calls',
]);

export function isChatToolsRailPanelId(id: string | null): id is ChatToolsRailPanelId {
  return id != null && CHAT_TOOLS_RAIL_PANEL_IDS.has(id as ChatToolsRailPanelId);
}

/** תחילית מזהה של פאנל הרחבת שיחה — מזהה דינמי פר כפתור, ולכן לא יכול לשבת ב-Set הסגור */
export const EXTENSION_PANEL_ID_PREFIX = 'extension-panel:';

/**
 * פאנלים שמוצגים כיחידה אחת עם המסילה (Dock). כולל פאנלי הרחבות — אחרת המסילה
 * נשארת צפה בין הצ'אט למגירה הפתוחה במקום להיכנס אליה.
 */
export function isChatToolsDockedPanelId(id: string | null): boolean {
  return isChatToolsRailPanelId(id) || (id != null && id.startsWith(EXTENSION_PANEL_ID_PREFIX));
}
